import _ from 'lodash'
import { createAction, createReducer } from 'redux-act'
import { baseUrl } from '../scripts/env'
import message from 'antd/lib/message'

import { fetchStat } from 'ducks/summary'
import axios from 'axios'
import l8n from 'l8n'

const REDUCER = 'withdrawals'
const NS = `@@${REDUCER}/`

export const CASE_NOT_ALLOWED_BY_STATUS = 1
export const CASE_NOT_ALLOWED_BY_HISTORY = 2
export const CASE_CONFIRMATION = 3
export const CASE_SUCCESS = 4

export const reset = createAction(`${NS}RESET`)
export const dialog = createAction(`${NS}DIALOG`)

export const caseNotAllowedByStatus = createAction(`${NS}CASE_NOT_ALLOWED_BY_STATUS`)
export const caseNotAllowedByHistory = createAction(`${NS}CASE_NOT_ALLOWED_BY_HISTORY`)
export const caseConfirmation = createAction(`${NS}CASE_CONFIRMATION`)
export const caseSuccess = createAction(`${NS}CASE_SUCCESS`)

export const createRequest = createAction(`${NS}CREATE_REQUEST`)
export const createSuccess = createAction(`${NS}CREATE_SUCCESS`)
export const createFailure = createAction(`${NS}CREATE_FAILURE`)

export const fetchRequest = createAction(`${NS}FETCH_REQUEST`)
export const fetchSuccess = createAction(`${NS}FETCH_SUCCESS`)
export const fetchFailure = createAction(`${NS}FETCH_FAILURE`)

const initialState = {
    isLoading: false,
    request: {
        case: CASE_CONFIRMATION,
        allowed: true,
        dialog: false,
        isSending: false
    },
    items: [],
    pagination: {
        current: 1,
        pageSize: 20,
        defaultPageSize: 20,
        showSizeChanger: true,
        pageSizeOptions: ['20', '50', '100', '200']
    }
}

export const create = () => async (dispatch, getState) => {
    dispatch(createRequest())
    const response = await axios({
        method: 'POST',
        url: `${baseUrl}/${REDUCER}/create`
    });
    
    if (_.get(response, 'data.ok', false) === false) {
        dispatch(createFailure())
        return false
    }
    
    const bounced = _.get(response, 'data.bounced', false)
    if (bounced) {
        dispatch(caseNotAllowedByHistory())
        return false
    }

    message.success(l8n.p_withdraw_request_confirmed_h)
    dispatch(createSuccess())
    dispatch(dialog(false))
    dispatch(fetch())
    dispatch(fetchStat())
    return true
}

export const fetch = input => async (dispatch) => {
    dispatch(fetchRequest())
    const params = _.mapValues(input, (value) => { return _.isArray(value) ? value[0] : value })
    const response = await axios({
        url: `${baseUrl}/${REDUCER}`,
        params
    });
  
    const pagination = _.get(response, 'data.pagination', false)
    const items = _.get(response, `data.${REDUCER}`, false)
    if (items === false || pagination === false) {
        dispatch(fetchFailure())
        return false
    }
    
    dispatch(fetchSuccess({items, pagination}))
    return true
}

export default createReducer(
  {
    [reset]: (state) => ({ ...state, request: { ...state.request, case: CASE_CONFIRMATION, allowed: true, dialog: false, isSending: false } }),
    [dialog]: (state, dialog) => ({ ...state, request: {...state.request, dialog} }),
    [caseNotAllowedByStatus]: (state) => ({ ...state, request: {...state.request, isSending : false, allowed: false, case: CASE_NOT_ALLOWED_BY_STATUS} }),
    [caseNotAllowedByHistory]: (state) => ({ ...state, request: {...state.request, isSending : false, allowed: false, case: CASE_NOT_ALLOWED_BY_HISTORY} }),
    [caseConfirmation]: (state) => ({ ...state, request: {...state.request, isSending : false, allowed: true, case: CASE_CONFIRMATION} }),
    [caseSuccess]: (state) => ({ ...state, request: {...state.request, isSending : false, allowed: false, case: CASE_SUCCESS} }),

    [createRequest]: (state) => ({ ...state, request: {...state.request, isSending : true} }),
    [createSuccess]: (state) => ({ ...state, request: {...state.request, isSending : false} }),
    [createFailure]: (state, error) => ({ ...state, request: {...state.request, ...error, isSending : false} }),

    [fetchRequest]: (state) => ({ ...state, isLoading : true }),
    [fetchSuccess]: (state, data) => {
        const items = data.items;
        const pagination = Object.assign(
            {}, 
            state.pagination, 
            _.mapKeys(data.pagination, (value, key) => { return _.camelCase(key) })
        );
        return { ...state, items, pagination, isLoading: false }
    },
    [fetchFailure]: (state, error) => ({ ...state, isLoading : false }),
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/ducks/withdrawals.js